import {useEffect} from 'react';
import {getUserId} from '@Libraries/user.library';
import {getRemoveBackgroundCost} from '@Utils/image.util';
import {setImageBgRemovalCreditsCost} from '@Components/image-bg-removal-credits-cost/image-bg-removal-credits-cost-slice';
import {useAppDispatch, useAppSelector} from '@/hooks';

const ongoingRequests = new Set<string>();

export function useGetRemoveImageBackgroundCreditsCost(hashedFilename: string, imageSource: string): number | null {
  const userId = getUserId();

  const dispatch = useAppDispatch();
  const backgroundRemovalCreditsCost = useAppSelector((state) => {
    return state.imageBgRemovalCreditsCost[hashedFilename] ?? null;
  });

  useEffect((): void => {
    if (backgroundRemovalCreditsCost !== null) {
      return;
    }

    if (ongoingRequests.has(hashedFilename)) {
      return;
    }

    ongoingRequests.add(hashedFilename);

    void getRemoveBackgroundCost(hashedFilename, imageSource)
      .then((credits) => {
        dispatch(
          setImageBgRemovalCreditsCost({
            imageKey: hashedFilename,
            credits,
          })
        );
      })
      .finally(() => {
        ongoingRequests.delete(hashedFilename);
      });
  });

  if (!userId) {
    return null;
  }

  return backgroundRemovalCreditsCost;
}
